export class MapNotFoundError extends Error {
	name = "MapNotFoundError";
}